import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "../images/Barsara.png";
import anonymous from "../../../../../assets/images/anonymous.jpg";
import TicketService from "../../../../../services/ticket";

export default function TicketChat({ ticket, onBack }) {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");

    const messagesContainerRef = useRef(null);


    useEffect(() => {
        const fetchMessages = async () => {
            if (!ticket?._id) return;

            try {
                const res = await TicketService.getTicketMessages(ticket._id);
                if (res.data?.success && Array.isArray(res.data.message)) {
                    const formattedMessages = res.data.message.map((msg) => ({
                        id: msg._id,
                        text: msg.description,
                        sender: msg.sender?.admin_id ? "admin" : "user",
                        createdAt: new Date(msg.createdAt).toLocaleString("fa-IR", {
                            dateStyle: "short",
                            timeStyle: "short",
                        }),
                    }));
                    setMessages(formattedMessages);
                }
            } catch (err) {
            }
        };


        setMessages([]);
        fetchMessages();
    }, [ticket]);


    useEffect(() => {
        if (messagesContainerRef.current) {
            messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
        }
    }, [messages]);


    const sendMessage = async () => {
        if (!newMessage.trim()) return;

        const tempMessage = {
            id: Date.now(),
            sender: "user",
            text: newMessage,
            createdAt: new Date().toLocaleString("fa-IR", {
                dateStyle: "short",
                timeStyle: "short",
            }),
        };

        setMessages((prev) => [...prev, tempMessage]);
        setNewMessage("");

        try {
            const body = {
                ticket_id: ticket._id,
                description: newMessage,
            };

            const res = await TicketService.answerTicket(body);

            if (res.data?.success && res.data.message) {
                setMessages((prev) => [
                    ...prev.filter((m) => m.text !== newMessage),
                    {
                        id: res.data.message._id,
                        sender: res.data.message.creator?.admin_id ? "admin" : "user",
                        text: res.data.message.description || res.data.en_message || "پاسخ ثبت شد",
                        createdAt: new Date(res.data.message.createdAt).toLocaleString("fa-IR", {
                            dateStyle: "short",
                            timeStyle: "short",
                        }),
                    },
                ]);
            }
        } catch (err) {
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now() + 1,
                    sender: "admin",
                    text: "ارسال پیام با خطا مواجه شد.",
                    createdAt: new Date().toLocaleString("fa-IR", {
                        dateStyle: "short",
                        timeStyle: "short",
                    }),
                },
            ]);
        }
    };
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col w-full lg:h-[calc(100vh-10rem)] h-full rounded-lg overflow-hidden bg-white"
        >
            <div className="flex justify-center h-full">
                {/* Messages */}
                <div
                    ref={messagesContainerRef}
                    className="md:w-3/4 w-full p-1 space-y-6 overflow-y-auto"
                    style={{
                        maxHeight: "60vh",
                        minHeight: "300px",
                        background: "inherit"
                    }}
                >
                    <AnimatePresence>
                        {messages.map((msg) => (
                            <motion.div
                                key={msg.id}
                                initial={{ opacity: 0, y: 20, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 20 }}
                                transition={{ duration: 0.4 }}
                                className={`flex ${msg.sender === "user" ? "justify-end" : "justify-start"} items-end`}
                            >
                                {/* پیام کاربر */}
                                {msg.sender === "user" && (
                                    <>
                                        <div className="flex flex-col max-w-[70%] items-end">
                                            <div
                                                className={`px-6 py-5 w-full text-sm leading-relaxed break-words relative bg-[#E0ECFE] text-gray-900 rounded-[2.5rem] rounded-bl-none`}
                                            >
                                                {msg.text}
                                            </div>
                                            <span className="w-[85%] text-[11px] text-gray-400 mt-1 mx-5 text-start">
                                                {msg.createdAt}
                                            </span>
                                        </div>
                                        <img
                                            src={anonymous}
                                            alt="user"
                                            className="w-8 h-8 rounded-full mr-2 mb-1"
                                        />
                                    </>
                                )}
                                {/* پیام ادمین */}
                                {msg.sender === "admin" && (
                                    <>
                                        <img
                                            src={Logo}
                                            alt="admin"
                                            className="w-8 h-8 rounded-full ml-2 mb-1"
                                        />
                                        <div className="flex flex-col max-w-[70%] items-start">
                                            <div
                                                className={`px-6 py-5 w-full text-sm leading-relaxed break-words relative bg-gray-100 text-gray-800 rounded-[2.5rem] rounded-br-none`}
                                            >
                                                {msg.text}
                                            </div>
                                            <span className="w-[85%] text-[11px] text-gray-400 mt-1 mx-5 text-end">
                                                {msg.createdAt}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </div>
            </div>

            {/* Input */}
            <div className="flex justify-center py-4 px-6 border-t bg-white gap-3">
                <input
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="پیام خود را بنویسید..."
                    className="flex-1 border rounded-full px-4 max-w-[660px] py-2 text-sm focus:outline-none"
                />
                <button
                    onClick={sendMessage}
                    className="ml-2 bg-blue-900 text-white w-24 px-4 py-2 rounded-full hover:bg-blue-800"
                >
                    ارسال
                </button>
            </div>
        </motion.div>
    );
}
